// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import { App, ComponentPublicInstance, VNode, h, render } from 'vue';
import uploadFromComponent from './index.vue';

interface UploadInstance extends ComponentPublicInstance {
  visible: { value: boolean } | boolean;
  callback: { value: (images: string[]) => void } | ((images: string[]) => void);
  isMore: { value: string } | string;
  openUpload?: (fn: (images: string[]) => void, more: string) => void;
}

interface UploadPlugin {
  install: (app: App) => void;
}

let uploadInstance: UploadInstance | null = null;
let uploadVNode: VNode | null = null;
let uploadContainer: HTMLElement | null = null;

const uploadFrom: UploadPlugin = {
    install(app: App) {
    // 创建上传组件实例
        const createUploadInstance = (): UploadInstance => {
            if (!uploadContainer) {
                uploadContainer = document.createElement('div');
                document.body.appendChild(uploadContainer);
            }

            uploadVNode = h(uploadFromComponent);
            // 继承主应用上下文，解决路由、store 等依赖
            (uploadVNode as any).appContext = (app as any)._context;

            render(uploadVNode, uploadContainer);

            return (uploadVNode.component!.exposed || uploadVNode.component!.proxy) as UploadInstance;
        };

        // 获取或创建全局实例
        const getUploadInstance = (): UploadInstance => {
            if (!uploadInstance) {
                uploadInstance = createUploadInstance();
            }
            return uploadInstance;
        };

        const assignRefValue = <T>(instance: UploadInstance, key: keyof UploadInstance, value: T) => {
            const target = instance[key];
            if (target && typeof target === 'object' && 'value' in target) {
                (target as { value: T }).value = value;
            } else {
                (instance as any)[key] = value;
            }
        };

        // 添加全局方法
        // isMore：'1' 单选 / '2' 多选；兼容 EB 传入数字 1/2
        app.config.globalProperties.$modalUpload = function(callback: (images: string[]) => void, isMore: string | number = '') {
            const more = isMore === '' || isMore == null ? '' : String(isMore);
            const instance = getUploadInstance();
            if (typeof instance.openUpload === 'function') {
                instance.openUpload(callback, more);
            } else {
                assignRefValue(instance, 'callback', callback);
                assignRefValue(instance, 'isMore', more);
                assignRefValue(instance, 'visible', true);
            }
        };
    }
};

export default uploadFrom;
